import type { IconNode } from '../types';

/**
 * @name hockey
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxNyIgY3k9IjE5IiByPSIzIiAvPgogIDxwYXRoIGQ9Ik0yLjggMTNhNS45NSA1Ljk1IDAgMSAwIDEwLjQgNmw4LjUtMTRhMS45NCAxLjk0IDAgMSAwLTMuNC0yTDkuNyAxN2ExLjg4IDEuODggMCAxIDEtMy40LTIgMS45NCAxLjk0IDAgMSAwLTMuNS0yIiAvPgogIDxwYXRoIGQ9Im0yMC42IDYuOC0zLjMtMi4xIiAvPgogIDxwYXRoIGQ9Im0xNS4yIDguMSAzLjMgMi4xIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/hockey
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hockey: IconNode = [
  ['circle', { cx: '17', cy: '19', r: '3', key: 'm9grcf' }],
  [
    'path',
    {
      d: 'M2.8 13a5.95 5.95 0 1 0 10.4 6l8.5-14a1.94 1.94 0 1 0-3.4-2L9.7 17a1.88 1.88 0 1 1-3.4-2 1.94 1.94 0 1 0-3.5-2',
      key: '1wqrwi',
    },
  ],
  ['path', { d: 'm20.6 6.8-3.3-2.1', key: 'ti4ez2' }],
  ['path', { d: 'm15.2 8.1 3.3 2.1', key: '2lrn57' }],
];

export default hockey;
